import { __assign } from "tslib";
import { textStyle } from '../v2/theme';
import { Platform } from "react-native";
export default {
  shadowStyles: {
    shadowColor: "rgba(0,0,0, .08)",
    shadowOffset: {
      height: 4,
      width: 2
    },
    shadowOpacity: 1,
    shadowRadius: 12,
    elevation: 3
  },
  aria: {
    hideLabel: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: 1
    },
    labelTag: {
      color: "#003087",
      fontSize: 14
    }
  },
  card: {
    padding: 10,
    innerStyle: {
      paddingVertical: 9,
      paddingHorizontal: 16,
      minHeight: 280
    }
  },
  navPanel: {
    listItemStyles: {
      borderBottomColor: "black",
      borderLeftColor: "white",
      borderLeftWidth: 3
    },
    subListItemStyles: {
      padding: 10
    },
    textItemContainerStyles: {
      flexDirection: 'row'
    },
    textItemStyles: {}
  },
  selectionListView: {
    rowHeaderStyles: {
      backgroundColor: "#FFF"
    },
    rowHeaderContainerStyles: {
      backgroundColor: "#FFF",
      paddingLeft: 10,
      marginLeft: 3,
      marginRight: 3
    },
    rowItemStyles: __assign({
      display: "flex",
      flexDirection: "row",
      paddingLeft: 10,
      paddingTop: 10,
      paddingBottom: 10,
      height: "auto",
      backgroundColor: "#FFF"
    }, textStyle.formLineWeight),
    bankPaymentItemStyles: __assign({
      display: "flex",
      flexDirection: "row",
      height: "auto",
      paddingHorizontal: 20,
      paddingVertical: 10
    }, textStyle.formLineWeight),
    bankPaymentHeader: {
      flexGrow: 2,
      fontSize: 14,
      fontWeight: "bold",
      color: "#006B95",
      padding: 10
    },
    fiftyWidth: {
      width: '50%'
    }
  },
  yearEndTaxes: {
    tableHeaderStyles: {
      textAlign: "left",
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20
    },
    tableRowStyles: {
      borderBottom: "1px solid #e9e9e9"
    },
    tableDataStyles: {
      width: '50%',
      verticalAlign: 'top',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20
    }
  },
  accountSettings: {
    titleContainer: {
      borderBottomWidth: 1,
      borderColor: "#e9e9e9",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      marginBottom: 0,
      width: "100%",
      alignSelf: "center"
    },
    header: {
      fontSize: 16
    },
    contentsHeading: {
      color: "#003087",
      fontWeight: "700"
    },
    inputLineContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      marginLeft: 60,
      width: "50%",
      height: '100%'
    },
    contentsContainer: {
      marginTop: 20,
      display: "flex",
      flexDirection: "column"
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      marginBottom: 20,
      width: "100%"
    },
    button: {
      minWidth: "40%"
    },
    pwVisible: {
      display: 'flex',
      position: "absolute",
      top: 20,
      height: 52,
      alignItems: 'center',
      right: "20%",
      zIndex: 100
    }
  },
  eDisbursement: {
    container: {
      flex: 1,
      padding: 16,
      paddingTop: 30,
      backgroundColor: '#fff'
    },
    head: {
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      height: 40,
      backgroundColor: '#d6ddeb'
    },
    text: {
      margin: 10,
      color: "#003087"
    },
    textHead: {
      margin: 10,
      fontWeight: "bold",
      color: "#003087",
      fontSize: 16
    },
    row: {
      flexDirection: 'row',
      backgroundColor: '#FFF1C1'
    },
    btn: {
      width: 58,
      height: 18,
      backgroundColor: '#78B7BB',
      borderRadius: 2
    },
    btnText: {
      textAlign: 'center',
      color: '#fff'
    },
    section: {
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 20,
      paddingBottom: 20
    },
    inputContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 10
    }
  },
  eDisbursementPopup: {
    button: {}
  },
  tables: {
    container: {
      flex: 1,
      padding: 16,
      paddingTop: 30,
      backgroundColor: '#fff'
    },
    head: {
      height: 40
    },
    text: {
      margin: 6
    },
    textHead: {
      margin: 6,
      fontWeight: "bold"
    },
    row: {
      flexDirection: 'row',
      backgroundColor: '#FFF1C1'
    },
    btn: {
      width: 58,
      height: 18,
      backgroundColor: '#78B7BB',
      borderRadius: 2
    },
    btnText: {
      textAlign: 'center',
      color: '#fff'
    }
  },
  contactUs: {
    itemStyles: {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      backgroundColor: "#FFF",
      overflow: "hidden",
      marginBottom: 10,
      paddingLeft: 20
    }
  },
  statementsDocs: {
    tabs: {
      height: "auto",
      marginLeft: 20,
      border: "1px solid #DDDDDD",
      borderBottom: "none",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      padding: 10,
      backgroundColor: "#efefef"
    }
  },
  wiscoTax: {
    section: {
      borderBottom: "1px solid #e9e9e9",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "nowrap",
      width: "100%",
      marginBottom: 10,
      paddingBottom: 10
    }
  },
  amortCalc: {
    section: {
      backgroundColor: "#FFF",
      marginLeft: 10,
      marginRight: 10
    },
    rowHeaderStyles: {
      fontSize: 16
    },
    tabPan: {
      border: "1px solid #DDDDDD",
      borderBottom: "none",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      padding: 10,
      color: "#006B95",
      backgroundColor: "#efefef"
    },
    selectedTab: {
      borderBottom: "none",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      color: "#FFF",
      backgroundColor: "#006B95"
    }
  },
  payoffRequest: {
    subHeader: {
      color: "#707070",
      fontWeight: "bold"
    },
    textContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 1
    },
    text: {
      textAlign: "center",
      flex: 1,
      flexShrink: 1
    },
    tile: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      padding: 20,
      height: "100%",
      borderRadius: 10,
      boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px"
    },
    refiPnmacBottomTileText: {
      fontSize: 16,
      textAlign: "center",
      marginTop: 20
    },
    bottomTile: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      paddingTop: 20,
      flex: 1,
      backgroundColor: "#FFF",
      borderRadius: 10,
      boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
      height: "100%"
    },
    refiPnmacBottomTile: {
      display: "flex",
      flexDirection: "column",
      cursor: "pointer",
      alignItems: "center",
      flex: 1,
      backgroundColor: "#FFF",
      borderRadius: 10,
      height: "100%",
      boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px"
    },
    bottomTileText: {
      fontSize: 16,
      textDecoration: "underline"
    },
    bottomTilePic: {
      height: 200,
      width: "100%",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10
    },
    sectionHeadline: {
      fontSize: 34
    },
    sectionSubheader: {
      color: "#707070",
      marginTop: 20
    },
    button: {
      marginTop: 40,
      width: "25%",
      backgroundColor: "#F1C400"
    },
    links: {
      width: "19%",
      height: "auto",
      textDecoration: 'none',
      cursor: 'pointer'
    }
  },
  oneTimePayment: {
    otpModalContainer: {
      padding: 16,
      backgroundColor: "#F2F2F2",
      borderRadius: 7,
      marginVertical: 15
    },
    otpModalText: {
      fontFamily: "HalenoirCompactText-Medium",
      textAlign: 'center',
      fontSize: 12,
      color: "#5C5C5C"
    },
    tabPan: {
      height: "auto",
      minHeight: Platform.OS === 'web' ? undefined : 58,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      padding: 10,
      marginRight: 6
    },
    labelText: {
      color: "#000"
    },
    tableHeader: __assign({
      padding: 10
    }, textStyle.defaultTextTitle),
    tableCell: {
      backgroundColor: "#FFF",
      padding: 10
    },
    sectionListContainer: {
      backgroundColor: "#FFF",
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      padding: 20
    }
  },
  newToPaymentsContainer: {
    paddingLeft: 14.9,
    paddingVertical: 13,
    backgroundColor: "white",
    borderRadius: 7,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginHorizontal: 15,
    marginVertical: 29,
    flexDirection: "row"
  },
  newToPaymentsText: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 12,
    color: "#333333"
  },
  seeHowItWorksText: {
    fontFamily: "HalenoirCompactText-Medium",
    fontSize: 12,
    color: "#117AAA",
    textDecorationLine: 'underline'
  },
  saveTimeContainer: {
    backgroundColor: "#56AC69",
    borderRadius: 7,
    marginTop: 21.5,
    paddingVertical: 10.8,
    paddingHorizontal: 15.9,
    display: "row",
    marginHorizontal: 15,
    borderColor: "transparent",
    flexDirection: "row",
    alignItems: "center"
  },
  saveTimeTitle: {
    color: "#FFFFFF",
    fontFamily: "Montserrat",
    fontWeight: "600",
    fontSize: 16
  },
  saveTimeSubtitle: {
    color: "#FFFFFF",
    fontFamily: "Montserrat",
    fontWeight: "600",
    fontSize: 12
  }
};